


import { useLocation } from "react-router-dom";
import { HeaderNav } from "./header-nav/header-nav";

import "./header.css"
import { BackButton } from "../../template/buttons/back-btn/back-btn";

export const Header = ({props}) => {

    const {about: {companyName}, banner} = props;

    const location = useLocation();

    const isHome = location.pathname === '/' ? true : false;

    return (
        <header className={`position-relative ${!isHome ? 'header-min' : ''}`}>
            <div className="header-banner">
                <img src={banner} alt=""  />
            </div>
            <div className="container-fluid h-100">
                <div className="nav-header row  h-100 position-relative">
                    {!isHome &&
                        <div className="p-0 position-absolute top-0 start-0">
                            <BackButton/>
                        </div>
                    }
                    <div className="nav-item col-12 h-100">
                        <div className="d-flex flex-column justify-content-center align-items-center h-100" >
                            <div className="title-item">{companyName}</div>
                           
                        </div>
                    </div>
                    {isHome && 
                        <HeaderNav props={props}/>
                    }
                </div>
            </div> 
        </header>
    )
}